import * as moment from 'moment'
import yup from 'civic-champs-shared/utils/yup'
import { isNil } from 'lodash'

export const EMAIL_VALIDATION_TEXT = 'Email must be a valid email address'
const PHONE_VALIDATION_TEXT = 'Phone number must be a valid US phone number'
const INTERNATIONAL_PHONE_VALIDATION_TEXT = 'Phone number must be a valid phone number'

const phoneFieldSchema = internationalPhoneEnabled =>
  internationalPhoneEnabled
    ? yup.string().e164PhoneNumber(INTERNATIONAL_PHONE_VALIDATION_TEXT).nullable()
    : yup.string().phoneNumber(PHONE_VALIDATION_TEXT).nullable()

export const getProfilePersonSchema = (internationalPhoneEnabled = false) =>
  yup.object({
    givenName: yup.string().trim().required('Please enter first name'),
    familyName: yup.string().trim().required('Please enter last name'),
    email: yup.string().email(EMAIL_VALIDATION_TEXT).trim().lowercase().nullable(),
    phoneNumber: phoneFieldSchema(internationalPhoneEnabled),
    homePhoneNumber: phoneFieldSchema(internationalPhoneEnabled),
    birthDate: yup
      .date()
      .nullable()
      .test(
        'birthDate',
        'Volunteers must be at least 13 years old',
        value => isNil(value) || moment().diff(moment(value), 'years') >= 13,
      ),
    address: yup
      .object()
      .shape({
        id: yup.number().id().nullable(),
        line1: yup.string().trim().nullable(),
        line2: yup.string().trim().nullable(),
        city: yup.string().trim().nullable(),
        country: yup.string().trim().nullable(),
        zip: yup.string().trim().nullable(),
      })
      .nullable(),
    emergencyContactRelationship: yup.string().nullable(),
    emergencyContact: yup
      .object()
      .shape({
        id: yup.number().id().nullable(),
        givenName: yup.string().trim().required("Please enter the emergency contact's first name"),
        familyName: yup.string().trim().required("Please enter the emergency contact's last name"),
        email: yup.string().email(EMAIL_VALIDATION_TEXT).trim().lowercase().nullable(),
        phoneNumber: phoneFieldSchema(internationalPhoneEnabled),
        homePhoneNumber: phoneFieldSchema(internationalPhoneEnabled),
        workPhoneNumber: phoneFieldSchema(internationalPhoneEnabled),
      })
      .nullable(),
  })

export const profilePersonSchema = getProfilePersonSchema(false)
